// extracted by mini-css-extract-plugin
export default {"report-content__container":"styles_report-content__container__3x+yf","report-content__content":"styles_report-content__content__JnpUt"};